import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetRolesById } from "../../lib/data";
import GetEditPermissions from "../../ui/permissionsUi/getEditPermissions";
import { useTranslation } from "react-i18next";

export default function Permissions () {

    const {permissionId} = useParams();
    const [permissionsData, setPermissionsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);  
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        setIsLoading(true);  
        const permissionData = await GetRolesById(permissionId);
        setPermissionsData([]);
        permissionData.permissions.map((e) => setPermissionsData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{currentLang === "en" ? "Permissions" : "الصلاحيات"} </h1>
                <GetEditPermissions permissionId={permissionId} permissionsData={permissionsData}/>
            </div>
        </div>
    );
};